"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_MODES = void 0;
var VIEW_MODES;
(function (VIEW_MODES) {
    VIEW_MODES["SITE"] = "site";
    VIEW_MODES["EDITOR"] = "editor";
    VIEW_MODES["PREVIEW"] = "preview";
    VIEW_MODES["DASHBOARD"] = "dashboard";
    VIEW_MODES["STANDALONE"] = "standalone";
})(VIEW_MODES = exports.VIEW_MODES || (exports.VIEW_MODES = {}));
//# sourceMappingURL=view-modes.js.map